import React, { useEffect, useRef, useState } from 'react';
import PerfectScrollbar from 'perfect-scrollbar';
import DataTable from 'react-data-table-component';
import bootstrap from 'bootstrap/dist/js/bootstrap.bundle';
import { Modal } from 'bootstrap';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { User, Layout, Plus, X, AtSign, PhoneCall, Lock, Eye, EyeOff, Edit, Trash2 } from 'react-feather';
import api from '../Api';

function List() {
  const containerRef = useRef(null);
  const tableRef = useRef(null);
  const [users, setUsers] = useState([]);
  const [showPassword, setShowPassword] = useState(false);
  const [registeredUser, setRegisteredUser] = useState(null);
  const [wilayahList, setWilayahList] = useState([]);
  const [roleList, setRoleList] = useState([]);
  const [currentRoleId, setCurrentRoleId] = useState(null);

  //   const api = axios.create({
  //   baseURL: "https://api.projectku.com/api", // ganti dengan domain atau IP server kamu
  //   headers: {
  //     "Content-Type": "application/json",
  //     Accept: "application/json",
  //   },
  // });

  const [formData, setFormData] = useState({
    username: '',
    email: '',
    phone: '',
    password: '',
    role_id: '',
    wilayah_id: '',
  });

  const [editUserId, setEditUserId] = useState(null);

  const [editLoading, setEditLoading] = useState(false);

  const [deleteLoadingId, setDeleteLoadingId] = useState(null);

  const [showEditPassword, setShowEditPassword] = useState(false);

  const [editFormData, setEditFormData] = useState({
    username: '',
    email: '',
    phone: '',
    password: '',
    password_confirmation: '',
    role_id: '',
    wilayah_id: '',
    status: 'active',
  });

  const fetchRoles = async () => {
    try {
      const res = await api.get('/roles');

      // response bisa [{id, name}] atau {data: [...]}
      const list = Array.isArray(res.data.data) ? res.data.data : Array.isArray(res.data) ? res.data : [];

      setRoleList(list);
    } catch (err) {
      console.error('Gagal fetch roles:', err.response || err);
      toast.error('Gagal mengambil data role');
    }
  };

  const fetchWilayah = async () => {
    try {
      const res = await api.get('/getwilayah/include-zero');

      // asumsi response: { data: [{ id, nama_wilayah }] }
      const list = Array.isArray(res.data.data) ? res.data.data : Array.isArray(res.data) ? res.data : [];

      setWilayahList(list);
    } catch (err) {
      console.error('Gagal fetch wilayah:', err.response || err);
      toast.error('Gagal mengambil data wilayah');
    }
  };

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleEditChange = (e) => {
    const { name, value } = e.target;

    setEditFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleOpenEdit = async (row) => {
    try {
      setEditLoading(true);

      /*
       * Ambil detail terbaru dari backend.
       */
      const res = await api.get(`/users/${row.id}`);

      const user = res.data?.data ?? res.data?.user ?? res.data;

      /*
       * Password HARUS selalu kosong.
       *
       * Jangan pernah mengambil password lama.
       */
      setEditFormData({
        username: user.username ?? '',
        email: user.email ?? '',
        phone: user.phone ?? '',

        password: '',
        password_confirmation: '',

        role_id: user.role_id !== null && user.role_id !== undefined ? String(user.role_id) : '',

        wilayah_id: user.wilayah_id !== null && user.wilayah_id !== undefined ? String(user.wilayah_id) : '',

        status: user.status ?? 'active',
      });

      setEditUserId(user.id);

      setShowEditPassword(false);

      /*
       * Buka modal setelah data tersedia.
       */
      const modalEl = document.getElementById('editUserModal');

      const modal = bootstrap.Modal.getOrCreateInstance(modalEl);

      modal.show();
    } catch (err) {
      console.error('Gagal mengambil detail user:', err.response || err);

      toast.error(err.response?.data?.message || 'Gagal mengambil data user');
    } finally {
      setEditLoading(false);
    }
  };

  const getPasswordStrength = (pwd) => {
    let strength = 0;
    if (pwd.length > 5) strength++;
    if (pwd.length > 8) strength++;
    if (/[A-Z]/.test(pwd)) strength++;
    if (/[0-9]/.test(pwd)) strength++;
    if (/[^A-Za-z0-9]/.test(pwd)) strength++;

    return strength;
  };

  const strength = getPasswordStrength(formData.password);

  const getStrengthLabel = () => {
    switch (strength) {
      case 0:
        return '';
      case 1:
        return 'Sangat Lemah';
      case 2:
        return 'Lemah';
      case 3:
        return 'Sedang';
      case 4:
        return 'Kuat';
      case 5:
        return 'Sangat Kuat';
      default:
        return '';
    }
  };

  const getStrengthColor = () => {
    switch (strength) {
      case 1:
        return 'bg-danger'; // merah
      case 2:
        return 'bg-warning'; // kuning
      case 3:
        return 'bg-info'; // biru
      case 4:
        return 'bg-primary'; // biru tua
      case 5:
        return 'bg-success'; // hijau
      default:
        return 'bg-light';
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    // Validasi domain email
    const allowedDomains = ['gmail.com', 'yahoo.com'];
    const emailValue = formData.email.trim();
    const domain = emailValue.split('@')[1]?.toLowerCase();

    if (!domain || !allowedDomains.includes(domain)) {
      toast.error('Email hanya boleh menggunakan domain gmail.com atau yahoo.com.');
      return;
    }

    // Validasi URL di input lain
    const urlPattern = /(https?:\/\/|www\.|t\.me|(?<!@)\.com|\.id|\.net|\.org|\.co|\.my|\.info|\.biz|\.link|\.me)/gi;

    // cek semua field kecuali email
    for (const [key, value] of Object.entries(formData)) {
      if (typeof value === 'string' && key !== 'email' && urlPattern.test(value)) {
        toast.error('Input tidak boleh mengandung link, URL, atau domain seperti .com, t.me, dll.');
        return;
      }
    }

    const invalidCharPattern = /[<>{}"'`$%^&*+=]/;

    for (const [key, value] of Object.entries(formData)) {
      if (typeof value === 'string' && key !== 'password' && invalidCharPattern.test(value)) {
        toast.error('Input tidak boleh mengandung simbol atau kutip berbahaya.');
        return;
      }
    }

    // Validasi field kosong selain role
    for (const [key, value] of Object.entries(formData)) {
      if (typeof value === 'string' && value.trim() === '') {
        toast.error(`${key} tidak boleh kosong atau hanya spasi.`);
        return;
      }
    }

    if (!formData.role_id) {
      toast.error('Role wajib dipilih');
      return;
    }

    if (!formData.wilayah_id) {
      toast.error('Wilayah wajib dipilih');
      return;
    }

    const phonePattern = /^(?:\+62|0)[0-9]{9,13}$/;
    if (!phonePattern.test(formData.phone)) {
      toast.warning('Nomor telepon tidak valid. Gunakan format 0812xxxx atau +62812xxxx.');
      return;
    }

    if (formData.password.length < 6) {
      toast.warning('Password minimal 6 karakter.');
      return;
    }

    for (const [key, value] of Object.entries(formData)) {
      if (value.length > 100) {
        toast.warning(`${key} terlalu panjang (maksimal 100 karakter).`);
        return;
      }
    }

    const sanitizeInput = (str) =>
      str.replace(/[&<>"']/g, (match) => {
        const map = {
          '&': '&amp;',
          '<': '&lt;',
          '>': '&gt;',
          '"': '&quot;',
          "'": '&#x27;',
        };
        return map[match];
      });

    try {
      const payload = {
        username: formData.username,
        email: formData.email,
        phone: formData.phone,
        password: formData.password,
        password_confirmation: formData.password,
        role_id: parseInt(formData.role_id, 10),
        wilayah_id: parseInt(formData.wilayah_id, 10),
      };
      const res = await api.post('/register', payload);

      console.log('Register sukses:', res.data);

      toast.success('Register berhasil!');

      const modalEl = document.getElementById('userModal');
      const modal = bootstrap.Modal.getInstance(modalEl);
      modal.hide();

      document.querySelectorAll('.modal-backdrop').forEach((el) => el.remove());
      document.body.classList.remove('modal-open');
      document.body.style = '';

      setFormData({
        username: '',
        email: '',
        phone: '',
        password: '',
        role_id: '',
        wilayah_id: '',
      });

      fetchUsers();
    } catch (err) {
      console.error('Register gagal:', err.response || err);
      toast.error(err.response?.data?.message || 'Register gagal, coba lagi!');
    }
  };

  const handleEditSubmit = async (e) => {
    e.preventDefault();

    if (!editUserId) {
      toast.error('User tidak ditemukan.');
      return;
    }

    /*
  |--------------------------------------------------------------------------
  | EMAIL VALIDATION
  |--------------------------------------------------------------------------
  */
    const emailValue = editFormData.email.trim();

    const allowedDomains = ['gmail.com', 'yahoo.com'];

    const domain = emailValue.split('@')[1]?.toLowerCase();

    if (!domain || !allowedDomains.includes(domain)) {
      toast.error('Email hanya boleh menggunakan domain gmail.com atau yahoo.com.');

      return;
    }

    /*
  |--------------------------------------------------------------------------
  | PHONE VALIDATION
  |--------------------------------------------------------------------------
  */
    const phonePattern = /^(?:\+62|0)[0-9]{9,13}$/;

    if (!phonePattern.test(editFormData.phone.trim())) {
      toast.warning('Nomor telepon tidak valid. Gunakan format 0812xxxx atau +62812xxxx.');

      return;
    }

    /*
  |--------------------------------------------------------------------------
  | REQUIRED
  |--------------------------------------------------------------------------
  */
    if (!editFormData.username.trim()) {
      toast.warning('Username wajib diisi.');

      return;
    }

    if (!editFormData.role_id) {
      toast.warning('Role wajib dipilih.');

      return;
    }

    if (!editFormData.wilayah_id) {
      toast.warning('Wilayah wajib dipilih.');

      return;
    }

    /*
  |--------------------------------------------------------------------------
  | PASSWORD OPTIONAL
  |--------------------------------------------------------------------------
  */
    if (editFormData.password && editFormData.password.length < 6) {
      toast.warning('Password baru minimal 6 karakter.');

      return;
    }

    if (editFormData.password !== editFormData.password_confirmation) {
      toast.warning('Konfirmasi password tidak sama.');

      return;
    }

    try {
      setEditLoading(true);

      /*
    |--------------------------------------------------------------------------
    | PAYLOAD DASAR
    |--------------------------------------------------------------------------
    */
      const payload = {
        username: editFormData.username.trim(),

        email: editFormData.email.trim().toLowerCase(),

        phone: editFormData.phone.trim(),

        role_id: parseInt(editFormData.role_id, 10),

        wilayah_id: parseInt(editFormData.wilayah_id, 10),

        status: editFormData.status,
      };

      /*
    |--------------------------------------------------------------------------
    | PASSWORD
    |--------------------------------------------------------------------------
    |
    | Hanya kirim password kalau diisi.
    |
    */
      if (editFormData.password) {
        payload.password = editFormData.password;

        payload.password_confirmation = editFormData.password_confirmation;
      }

      /*
    |--------------------------------------------------------------------------
    | UPDATE
    |--------------------------------------------------------------------------
    */
      const res = await api.put(`/users/${editUserId}`, payload);

      toast.success(res.data?.message || 'Data user berhasil diperbarui');

      /*
    |--------------------------------------------------------------------------
    | TUTUP MODAL
    |--------------------------------------------------------------------------
    */
      const modalEl = document.getElementById('editUserModal');

      const modal = bootstrap.Modal.getInstance(modalEl);

      modal?.hide();

      /*
    |--------------------------------------------------------------------------
    | RESET
    |--------------------------------------------------------------------------
    */
      setEditUserId(null);

      setShowEditPassword(false);

      setEditFormData({
        username: '',
        email: '',
        phone: '',
        password: '',
        password_confirmation: '',
        role_id: '',
        wilayah_id: '',
        status: 'active',
      });

      /*
    |--------------------------------------------------------------------------
    | REFRESH TABLE
    |--------------------------------------------------------------------------
    */
      await fetchUsers();
    } catch (err) {
      console.error('Update user gagal:', err.response || err);

      /*
       * Laravel validation error
       */
      const errors = err.response?.data?.errors;

      if (errors) {
        const firstError = Object.values(errors).flat()[0];

        toast.error(firstError || 'Data tidak valid');
      } else {
        toast.error(err.response?.data?.message || 'Gagal memperbarui user');
      }
    } finally {
      setEditLoading(false);
    }
  };

  const [searchEmail, setSearchEmail] = useState('');
  const [filterRole, setFilterRole] = useState('');

  const fetchUsers = async () => {
    try {
      const res = await api.get('/users');

      const userList = Array.isArray(res.data.data) ? res.data.data : [];

      setUsers(userList);
    } catch (err) {
      console.error('Gagal fetch users:', err.response || err);
    }
  };

  useEffect(() => {
    fetchUsers();
    fetchWilayah();
    fetchRoles();
  }, []);

  const handleDelete = async (row) => {
    /*
  |--------------------------------------------------------------------------
  | KONFIRMASI
  |--------------------------------------------------------------------------
  */
    const confirmed = window.confirm(`Apakah Anda yakin ingin menghapus user "${row.username}"?`);

    if (!confirmed) {
      return;
    }

    try {
      setDeleteLoadingId(row.id);

      /*
    |--------------------------------------------------------------------------
    | DELETE USER
    |--------------------------------------------------------------------------
    */
      const res = await api.delete(`/users/${row.id}/destroy`);

      toast.success(res.data?.message || 'User berhasil dihapus');

      /*
    |--------------------------------------------------------------------------
    | REFRESH TABLE
    |--------------------------------------------------------------------------
    */
      await fetchUsers();
    } catch (err) {
      console.error('Delete user gagal:', err.response || err);

      toast.error(err.response?.data?.message || 'Gagal menghapus user');
    } finally {
      setDeleteLoadingId(null);
    }
  };

  // Definisi kolom untuk react-data-table-component
  // const columns = [
  //   {
  //     name: 'No',
  //     selector: (row, index) => index + 1,
  //     width: '60px',
  //   },
  //   {
  //     name: 'Username',
  //     selector: (row) => row.username,
  //     sortable: true,
  //   },
  //   {
  //     name: 'Email',
  //     selector: (row) => row.email,
  //     sortable: true,
  //   },
  //   {
  //     name: 'Telp',
  //     selector: (row) => row.phone,
  //   },
  //   {
  //     name: 'Role',
  //     selector: (row) => row.role,
  //   },
  //   {
  //     name: 'Status',
  //     selector: (row) => row.status || 'inactive',
  //     cell: (row) => {
  //       let displayStatus = row.status;

  //       if (row.status?.toLowerCase() === 'pending_verification') {
  //         displayStatus = 'pending verifikasi';
  //       } else if (!row.status) {
  //         displayStatus = 'inactive';
  //       }

  //       return (
  //         <span className={`badge ${row.status?.toLowerCase() === 'active' ? 'bg-success' : 'bg-danger'}`}>
  //           {displayStatus}
  //         </span>
  //       );
  //     },
  //   },

  //   {
  //     name: 'Action',
  //     width: '220px',
  //     minWidth: '220px',
  //     center: true,
  //     grow: 0,

  //     cell: (row) => (
  //       <div
  //         className="d-flex align-items-center justify-content-center gap-2 flex-nowrap"
  //         style={{
  //           width: '100%',
  //           whiteSpace: 'nowrap',
  //         }}
  //       >
  //         {/* EDIT */}
  //         <button
  //           type="button"
  //           className="btn btn-warning btn-sm d-inline-flex align-items-center justify-content-center gap-1"
  //           style={{
  //             minWidth: '80px',
  //             whiteSpace: 'nowrap',
  //             flexShrink: 0,
  //           }}
  //           onClick={() => handleOpenEdit(row)}
  //           disabled={editLoading || deleteLoadingId === row.id}
  //         >
  //           <Edit size={14} />
  //           <span>Edit</span>
  //         </button>

  //         {/* DELETE */}
  //         <button
  //           type="button"
  //           className="btn btn-danger btn-sm d-inline-flex align-items-center justify-content-center gap-1"
  //           style={{
  //             minWidth: '90px',
  //             whiteSpace: 'nowrap',
  //             flexShrink: 0,
  //           }}
  //           onClick={() => handleDelete(row)}
  //           disabled={deleteLoadingId === row.id}
  //         >
  //           {deleteLoadingId === row.id ? (
  //             <>
  //               <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true" />
  //             </>
  //           ) : (
  //             <>
  //               <Trash2 size={14} />
  //               <span>Delete</span>
  //             </>
  //           )}
  //         </button>
  //       </div>
  //     ),

  //     ignoreRowClick: true,
  //     allowOverflow: true,
  //     button: true,
  //   },
  // ];

  const columns = [
    {
      name: 'No',
      selector: (row, index) => index + 1,
      width: '70px',
      center: true,
      grow: 0,
    },

    {
      name: 'Username',
      selector: (row) => row.username,
      sortable: true,
      minWidth: '160px',
    },

    {
      name: 'Email',
      selector: (row) => row.email,
      sortable: true,
      minWidth: '230px',
      wrap: true,
    },

    {
      name: 'Telp',
      selector: (row) => row.phone,
      minWidth: '170px',
    },

    {
      name: 'Role',
      selector: (row) => row.role,
      minWidth: '140px',
    },

    {
      name: 'Status',
      minWidth: '150px',

      selector: (row) => row.status || 'inactive',

      cell: (row) => {
        let displayStatus = row.status;

        if (row.status?.toLowerCase() === 'pending_verification') {
          displayStatus = 'pending verifikasi';
        } else if (!row.status) {
          displayStatus = 'inactive';
        }

        return (
          <span className={`badge ${row.status?.toLowerCase() === 'active' ? 'bg-success' : 'bg-danger'}`}>
            {displayStatus}
          </span>
        );
      },
    },

    {
      name: 'Action',
      width: '220px',
      minWidth: '220px',
      center: true,
      grow: 0,

      cell: (row) => (
        <div
          className="d-flex align-items-center justify-content-center gap-2 flex-nowrap"
          style={{
            width: '100%',
            whiteSpace: 'nowrap',
          }}
        >
          {/* EDIT */}
          <button
            type="button"
            className="btn btn-warning btn-sm d-inline-flex align-items-center justify-content-center gap-1"
            style={{
              minWidth: '80px',
              whiteSpace: 'nowrap',
              flexShrink: 0,
            }}
            onClick={() => handleOpenEdit(row)}
            disabled={editLoading || deleteLoadingId === row.id}
          >
            <Edit size={14} />
            <span>Edit</span>
          </button>

          {/* DELETE */}
          <button
            type="button"
            className="btn btn-danger btn-sm d-inline-flex align-items-center justify-content-center gap-1"
            style={{
              minWidth: '90px',
              whiteSpace: 'nowrap',
              flexShrink: 0,
            }}
            onClick={() => handleDelete(row)}
            disabled={deleteLoadingId === row.id}
          >
            {deleteLoadingId === row.id ? (
              <span className="spinner-border spinner-border-sm" role="status" />
            ) : (
              <>
                <Trash2 size={14} />
                <span>Delete</span>
              </>
            )}
          </button>
        </div>
      ),

      ignoreRowClick: true,
      allowOverflow: true,
      button: true,
    },
  ];

  const filteredUsers = users.filter((user) => {
    const matchEmail = user.email?.toLowerCase().includes(searchEmail.toLowerCase());

    const matchRole = filterRole
      ? String(user.role_id) === String(filterRole) ||
        user.role === roleList.find((r) => String(r.id) === String(filterRole))?.name
      : true;

    return matchEmail && matchRole;
  });

  // === init PerfectScrollbar & DataTable ===
  useEffect(() => {
    let ps;
    if (containerRef.current) {
      ps = new PerfectScrollbar(containerRef.current);
    }
    if (tableRef.current) {
      new DataTable(tableRef.current);
    }
    return () => {
      if (ps) ps.destroy();
    };
  }, []);

  useEffect(() => {
    try {
      const user = JSON.parse(localStorage.getItem('user'));

      if (user?.role_id !== undefined) {
        setCurrentRoleId(Number(user.role_id));
      }
    } catch (error) {
      console.error('Gagal membaca user login:', error);
    }
  }, []);

  const allowedAddRoles = [2, 3, 5, 6];

  const canAddUser = allowedAddRoles.includes(Number(currentRoleId));

  return (
    <>
      <div className="page-title">
        <div className="row">
          <div className="col-12 col-md-6 order-md-1 order-last">
            <h3>Manajemen User</h3>
            <p className="text-subtitle text-muted">Kelola data akun pengguna dalam sistem.</p>
          </div>
          <div className="col-12 col-md-6 order-md-2 order-first">
            <nav aria-label="breadcrumb" className="breadcrumb-header">
              <ol className="breadcrumb">
                <li className="breadcrumb-item">
                  <a href="/Dashboard">Manajemen</a>
                </li>
                <li className="breadcrumb-item active" aria-current="page">
                  Users
                </li>
              </ol>
            </nav>
          </div>
        </div>
      </div>

      <section className="section">
        <div className="card">
          <div className="card-header d-flex justify-content-between align-items-center">
            <h4 className="mb-0">List User</h4>
          </div>
          <div className="modal fade" id="userModal" tabIndex="-1" aria-labelledby="userModalLabel" aria-hidden="true">
            <div className="modal-dialog modal-dialog-centered modal-lg">
              <div className="modal-content">
                <div className="modal-header">
                  <h5 className="modal-title" id="userModalLabel">
                    Tambah User
                  </h5>
                  <button
                    type="button"
                    className="border-0 bg-transparent"
                    data-bs-dismiss="modal"
                    aria-label="Close"
                    style={{
                      padding: 0,
                      lineHeight: 1,
                      boxShadow: 'none',
                      outline: 'none',
                    }}
                    onFocus={(e) => e.target.blur()} // opsional: biar gak ada outline pas klik
                  >
                    <X size={24} strokeWidth={2} />
                  </button>
                </div>
                <div className="modal-body">
                  <form onSubmit={handleSubmit}>
                    <div className="row g-3 mb-4">
                      <div className="col-md-6">
                        <label className="form-label">Username</label>
                        <div className="form-group position-relative has-icon-left">
                          <input
                            type="text"
                            name="username"
                            className="form-control"
                            placeholder="Username"
                            value={formData.username}
                            onChange={handleChange}
                          />
                          <div className="form-control-icon">
                            <User size={16} />
                          </div>
                        </div>
                      </div>
                      <div className="col-md-6">
                        <label className="form-label">Email</label>
                        <div className="form-group position-relative has-icon-left">
                          <input
                            type="email"
                            name="email"
                            id="email"
                            className="form-control"
                            placeholder="Email"
                            value={formData.email}
                            onChange={handleChange}
                          />
                          <div className="form-control-icon">
                            <AtSign size={16} />
                          </div>
                        </div>
                      </div>
                      <div className="col-md-6">
                        <label className="form-label">No. Telp</label>
                        <div className="form-group position-relative has-icon-left">
                          <input
                            type="tel"
                            name="phone"
                            className="form-control"
                            placeholder="Contoh: 0812xxxxxxxxx"
                            value={formData.phone}
                            onChange={handleChange}
                          />
                          <div className="form-control-icon">
                            <PhoneCall size={16} />
                          </div>
                        </div>
                      </div>
                      <div className="col-md-6">
                        <label className="form-label">Password</label>
                        <div className="form-group position-relative has-icon-left">
                          <input
                            type={showPassword ? 'text' : 'password'}
                            name="password"
                            className="form-control ps-5 pe-5"
                            placeholder="Password"
                            value={formData.password}
                            onChange={handleChange}
                            autoComplete="new-password"
                          />
                          {/* Ikon lock di kiri */}
                          <div
                            className="form-control-icon"
                            style={{
                              position: 'absolute',
                              top: '50%',
                              transform: 'translateY(-50%)',
                            }}
                          >
                            <Lock size={16} />
                          </div>

                          {/* Ikon mata di kanan */}
                          <div
                            style={{
                              position: 'absolute',
                              right: '15px',
                              top: '50%',
                              transform: 'translateY(-50%)',
                              cursor: 'pointer',
                            }}
                            onClick={() => setShowPassword(!showPassword)}
                          >
                            {showPassword ? <EyeOff size={16} /> : <Eye size={16} />}
                          </div>
                        </div>
                        {formData.password && (
                          <div className="mt-2">
                            <div className="progress" style={{ height: '6px' }}>
                              <div
                                className={`progress-bar ${getStrengthColor()}`}
                                role="progressbar"
                                style={{
                                  width: `${(strength / 5) * 100}%`,
                                }}
                              ></div>
                            </div>
                            <small className="text-muted">{getStrengthLabel()}</small>
                          </div>
                        )}
                      </div>

                      <div className="col-md-6">
                        <label className="form-label">Role</label>
                        <select name="role_id" className="form-select" value={formData.role_id} onChange={handleChange}>
                          <option value="">-- Pilih Role --</option>

                          {roleList.map((role, index) => (
                            <option key={role.id ?? `role-${index}`} value={String(role.id)}>
                              {role.name}
                            </option>
                          ))}
                        </select>
                      </div>

                      <div className="col-md-6">
                        <label className="form-label">Wilayah</label>
                        <select
                          name="wilayah_id"
                          className="form-select"
                          value={formData.wilayah_id}
                          onChange={handleChange}
                        >
                          <option value="">-- Pilih Wilayah --</option>

                          {wilayahList.map((wilayah, index) => (
                            <option key={wilayah.kd_wilayah ?? `wilayah-${index}`} value={String(wilayah.kd_wilayah)}>
                              {wilayah.nama_wilayah}
                            </option>
                          ))}
                        </select>
                      </div>
                    </div>
                    <div className="modal-footer">
                      <button type="button" className="btn btn-secondary" data-bs-dismiss="modal">
                        Batal
                      </button>
                      <button type="submit" className="btn btn-primary">
                        Simpan
                      </button>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>

          {/* =====================================================
    MODAL EDIT USER
===================================================== */}
          <div
            className="modal fade"
            id="editUserModal"
            tabIndex="-1"
            aria-labelledby="editUserModalLabel"
            aria-hidden="true"
          >
            <div className="modal-dialog modal-dialog-centered modal-lg">
              <div className="modal-content">
                {/* ================= HEADER ================= */}
                <div className="modal-header">
                  <h5 className="modal-title" id="editUserModalLabel">
                    Edit User
                  </h5>

                  <button type="button" className="border-0 bg-transparent" data-bs-dismiss="modal" aria-label="Close">
                    <X size={24} strokeWidth={2} />
                  </button>
                </div>

                {/* ================= BODY ================= */}
                <div className="modal-body">
                  <form onSubmit={handleEditSubmit} autoComplete="off">
                    <div className="row g-3 mb-4">
                      {/* ================= USERNAME ================= */}
                      <div className="col-md-6">
                        <label className="form-label">Username</label>

                        <div className="form-group position-relative has-icon-left">
                          <input
                            type="text"
                            name="username"
                            className="form-control"
                            placeholder="Username"
                            value={editFormData.username}
                            onChange={handleEditChange}
                            required
                          />

                          <div className="form-control-icon">
                            <User size={16} />
                          </div>
                        </div>
                      </div>

                      {/* ================= EMAIL ================= */}
                      <div className="col-md-6">
                        <label className="form-label">Email</label>

                        <div className="form-group position-relative has-icon-left">
                          <input
                            type="email"
                            name="email"
                            className="form-control"
                            placeholder="Email"
                            value={editFormData.email}
                            onChange={handleEditChange}
                            required
                          />

                          <div className="form-control-icon">
                            <AtSign size={16} />
                          </div>
                        </div>
                      </div>

                      {/* ================= PHONE ================= */}
                      <div className="col-md-6">
                        <label className="form-label">No. Telp</label>

                        <div className="form-group position-relative has-icon-left">
                          <input
                            type="tel"
                            name="phone"
                            className="form-control"
                            placeholder="Contoh: 0812xxxxxxxxx"
                            value={editFormData.phone}
                            onChange={handleEditChange}
                            required
                          />

                          <div className="form-control-icon">
                            <PhoneCall size={16} />
                          </div>
                        </div>
                      </div>

                      {/* ================= STATUS ================= */}
                      <div className="col-md-6">
                        <label className="form-label">Status</label>

                        <select
                          name="status"
                          className="form-select"
                          value={editFormData.status}
                          onChange={handleEditChange}
                        >
                          <option value="active">Active</option>

                          <option value="nonactive">Non Active</option>
                        </select>
                      </div>

                      {/* ================= ROLE ================= */}
                      <div className="col-md-6">
                        <label className="form-label">Role</label>

                        <select
                          name="role_id"
                          className="form-select"
                          value={editFormData.role_id}
                          onChange={handleEditChange}
                          required
                        >
                          <option value="">-- Pilih Role --</option>

                          {roleList.map((role, index) => (
                            <option key={role.id ?? `edit-role-${index}`} value={String(role.id)}>
                              {role.name}
                            </option>
                          ))}
                        </select>
                      </div>

                      {/* ================= WILAYAH ================= */}
                      <div className="col-md-6">
                        <label className="form-label">Wilayah</label>

                        <select
                          name="wilayah_id"
                          className="form-select"
                          value={editFormData.wilayah_id}
                          onChange={handleEditChange}
                          required
                        >
                          <option value="">-- Pilih Wilayah --</option>

                          {wilayahList.map((wilayah, index) => (
                            <option
                              key={wilayah.kd_wilayah ?? `edit-wilayah-${index}`}
                              value={String(wilayah.kd_wilayah)}
                            >
                              {wilayah.nama_wilayah}
                            </option>
                          ))}
                        </select>
                      </div>

                      {/* ================= PASSWORD BARU ================= */}
                      <div className="col-md-6">
                        <label className="form-label">Password Baru</label>

                        <div className="form-group position-relative has-icon-left">
                          <input
                            type={showEditPassword ? 'text' : 'password'}
                            name="password"
                            className="form-control ps-5 pe-5"
                            placeholder="Kosongkan jika tidak ingin mengganti"
                            value={editFormData.password}
                            onChange={handleEditChange}
                            autoComplete="new-password"
                          />

                          <div className="form-control-icon">
                            <Lock size={16} />
                          </div>

                          <div
                            style={{
                              position: 'absolute',
                              right: '15px',
                              top: '50%',
                              transform: 'translateY(-50%)',
                              cursor: 'pointer',
                            }}
                            onClick={() => setShowEditPassword((prev) => !prev)}
                          >
                            {showEditPassword ? <EyeOff size={16} /> : <Eye size={16} />}
                          </div>
                        </div>

                        <small className="text-muted">Kosongkan jika password tidak ingin diubah.</small>
                      </div>

                      {/* ================= CONFIRM PASSWORD ================= */}
                      <div className="col-md-6">
                        <label className="form-label">Konfirmasi Password Baru</label>

                        <div className="form-group position-relative has-icon-left">
                          <input
                            type={showEditPassword ? 'text' : 'password'}
                            name="password_confirmation"
                            className="form-control"
                            placeholder="Ulangi password baru"
                            value={editFormData.password_confirmation}
                            onChange={handleEditChange}
                            autoComplete="new-password"
                          />

                          <div className="form-control-icon">
                            <Lock size={16} />
                          </div>
                        </div>
                      </div>
                    </div>

                    {/* ================= FOOTER ================= */}
                    <div className="modal-footer">
                      <button
                        type="button"
                        className="btn btn-secondary"
                        data-bs-dismiss="modal"
                        disabled={editLoading}
                      >
                        Batal
                      </button>

                      <button type="submit" className="btn btn-primary" disabled={editLoading}>
                        {editLoading ? (
                          <>
                            <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true" />
                            Menyimpan...
                          </>
                        ) : (
                          <>
                            <Edit size={16} className="me-1" />
                            Simpan Perubahan
                          </>
                        )}
                      </button>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>

          <div className="card-body">
            <div className="row mb-3">
              <div className={canAddUser ? 'col-md-6' : 'col-md-7'}>
                <input
                  type="text"
                  className="form-control"
                  placeholder="Cari berdasarkan email..."
                  value={searchEmail}
                  onChange={(e) => setSearchEmail(e.target.value)}
                />
              </div>

              <div className={canAddUser ? 'col-md-4' : 'col-md-5'}>
                <select className="form-select" value={filterRole} onChange={(e) => setFilterRole(e.target.value)}>
                  <option value="">-- Semua Role --</option>
                  {roleList.map((role) => (
                    <option key={role.id} value={role.id}>
                      {role.name}
                    </option>
                  ))}
                </select>
              </div>

              {canAddUser && (
                <div className="col-md-2">
                  <button
                    type="button"
                    className="btn btn-primary d-flex align-items-center gap-1 w-100"
                    data-bs-toggle="modal"
                    data-bs-target="#userModal"
                  >
                    <Plus size={16} />
                    Tambah
                  </button>
                </div>
              )}
            </div>

            <DataTable columns={columns} data={filteredUsers} pagination highlightOnHover striped responsive />
          </div>
        </div>
      </section>
      <ToastContainer position="top-right" autoClose={3000} />
    </>
  );
}

export default List;
